import { v4 as uuidv4 } from "uuid";
export class AssetPropertyModel {
    constructor() {
        this.id = uuidv4();
        this.assetTypePropertyName = "";
        this.isMandatory = false;
        this.dataTypeId = "";
        this.controlTypeId = "";
        this.controlDataListId = "";
        this.assetTypePropertyValueId = "";
        this.assetTypePropertyValue = "";
        this.controlDataListValue = [];
    }
}
export class AssetProperty extends AssetPropertyModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
